class ProductVariantSelector {
  constructor(container) {
    this.container = container;
    this.variants = JSON.parse(this.container.dataset.variants);
    this.currentVariant = JSON.parse(this.container.dataset.currentVariant);
    this.variantSelectors = this.container.querySelectorAll('.variant-selector');
    this.variantIdInputs = this.container.querySelectorAll('.variant-id-selector');
    this.priceElement = this.container.querySelector('.js-price');
    this.form = this.container.querySelector('form');
    this.colorLabels = this.container.querySelectorAll('.selected-color-label');
    
    this.initializeSelectors();
    this.initializeForm();
    this.initializeColorLabels();
  }

  initializeSelectors() {
    this.variantSelectors.forEach(selector => {
      selector.addEventListener('change', (event) => this.onVariantChange(event));
    });
  }

  initializeForm() {
    if (this.form) {
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.addToCart();
      });
    }
  }

  initializeColorLabels() {
    this.variantSelectors.forEach(selector => {
      if (selector.classList.contains('color-selector')) {
        selector.addEventListener('change', (event) => this.updateColorLabel(event));
      }
    });
  }

  // addToCart() {
  //   const selectedVariantInput = this.container.querySelector('input[name="id"]:checked');
  //   if (!selectedVariantInput) return;

  //   const variantId = selectedVariantInput.value;
  //   const quantity = this.form.querySelector('input[name="quantity"]').value || 1;

  //   const data = {
  //     'items': [{
  //       'id': variantId,
  //       'quantity': parseInt(quantity)
  //     }]
  //   };

  //   fetch('/cart/add.js', {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json'
  //     },
  //     body: JSON.stringify(data)
  //   })
  //   .then(response => response.json())
  //   .then(data => {
  //     // Open cart drawer or show success message
  //     document.querySelector('.cart-drawer').classList.add('is-open');
  //   })
  //   .catch((error) => {
  //     console.error('Error:', error);
  //   });
  // }

  onVariantChange(event) {
    const selectedOptions = this.getSelectedOptions();
    const variantTitle = selectedOptions.join(' / ');
    
    const matchingVariantInput = Array.from(this.variantIdInputs).find(
      input => input.dataset.variantTitle === variantTitle
    );
    
    if (matchingVariantInput) {
      matchingVariantInput.checked = true;
      
      const matchedVariant = this.variants.find(variant => variant.id.toString() === matchingVariantInput.value);
      
      if (matchedVariant) {
        this.updatePrice(matchedVariant.price);
        this.updateURL(matchedVariant);
        
        // Find the variant's featured media
        const variantMedia = this.variants.find(v => v.id === matchedVariant.id)?.featured_media;
        
        const variantChangeEvent = new CustomEvent('variant:changed', {
          detail: { 
            variant: matchedVariant,
            featured_media: variantMedia
          }
        });
        this.container.dispatchEvent(variantChangeEvent);
      }
    }
  }

  getSelectedOptions() {
    const selections = [];
    this.variantSelectors.forEach(selector => {
      if (selector.checked) {
        selections.push(selector.value);
      }
    });
    return selections;
  }

  updatePrice(price) {
    // Format price according to your shop's money format
    const formattedPrice = this.formatMoney(price);
    this.priceElement.textContent = formattedPrice;
  }

  updateURL(variant) {
    if (!variant) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  formatMoney(cents) {
    // Implement your shop's money formatting here
    return (cents/100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
  }

  updateColorLabel(event) {
    // Clear all color labels first
    this.colorLabels.forEach(label => {
      label.textContent = '';
    });

    // Show the selected color label
    if (event.target.checked) {
      const colorValue = event.target.value;
      const labelElement = this.container.querySelector(`.selected-color-label[data-color="${colorValue}"]`);
      if (labelElement) {
        labelElement.textContent = colorValue;
      }
    }
  }
}

// Initialize the variant selector
document.addEventListener('DOMContentLoaded', () => {
  const productForms = document.querySelectorAll('.js-product-form');
  productForms.forEach(form => new ProductVariantSelector(form));
});